import { useParams, useNavigate } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { trpcClient } from "@/lib/trpc";
import { Loader2 } from "lucide-react";
import ReturnDeliveryForm from "./ReturnDeliveryForm";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";

export default function DeliveryReturnPage() {
  const { deliveryId } = useParams({ strict: false });
  const navigate = useNavigate();

  const { data: delivery, isLoading } = useQuery({
    queryKey: ["delivery", deliveryId],
    queryFn: async () => {
      if (!deliveryId) throw new Error("No ID");
      return trpcClient.deliveries.getById.query({ id: deliveryId });
    },
    enabled: !!deliveryId,
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-500" />
      </div>
    );
  }

  if (!delivery) {
    return <div className="p-4 text-red-500">Không tìm thấy đơn giao hàng</div>;
  }

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Giao Hàng", to: "/delivery" },
        { label: delivery.deliveryId, to: `/delivery/${delivery.id}` },
        { label: "Trả Hàng" },
      ]}
      title={`Trả Hàng ${delivery.deliveryId}`}
      onBack={() => navigate({ to: `/delivery/${delivery.id}` })}
      showContextPanel={false}
    >
      <div className="max-w-5xl mx-auto p-4 md:p-6 space-y-6">
        <ReturnDeliveryForm
          initialData={delivery}
          onCancel={() => navigate({ to: `/delivery/${delivery.id}` })}
        />
      </div>
    </StandardDetailLayout>
  );
}
